import React, { useState, useEffect } from 'react';
import {
	Button,
	Dialog,
	DialogContent,
	DialogFooter,
	ExtendedTheme,
	TextBlock
} from 'neon-design-system';
import { ManageTemplateDialogBase } from './ManageTemplate';
import { createStyles, makeStyles } from '@material-ui/core';

const useDialogStyles = makeStyles((theme: ExtendedTheme) => createStyles({
	dialogCaption: {
		display: 'flex'
	},
	dialogCheckbox: {
		marginTop: theme.spacing(2)
	}
}));

interface ManageTemplateDialogProps extends ManageTemplateDialogBase {
	dialogOpenState: boolean;
	openDialog?: () => void;
	closeDialog: () => void;
	title: string;
	submitBtnText: string;
	submitBtnColorType: any;
	submitBtnDisabled?: boolean;
	cancelBtnText?: string;
	cancelBtnColorType?: any;
}

const ManageTemplateDialog: React.FC<ManageTemplateDialogProps> = (props) => {
	const classes = useDialogStyles();
	const [ busy, setBusy ] = useState(false);
	const {
		dialogMessage,
		dialogOpenState,
		closeDialog,
		onDelete = () => { }
	} = props;

	useEffect(() => {
		if (dialogOpenState) {
			setBusy(false);
		}
	}, [dialogOpenState]);

	return (
		<Dialog
			id={'confirmation-dialog'}
			title={props.title}
			maxWidth={500}
			open={dialogOpenState}
			handleClose={closeDialog}>
			<DialogContent>
				<div>
					<div className={classes.dialogCaption}>
						{dialogMessage &&
							<TextBlock
								styleName="body"
								color="grey"
								shade={200}>{dialogMessage}</TextBlock>}
						{props.children}
					</div>
				</div>
			</DialogContent>
			<DialogFooter>
				<Button
					id="confirmation-dialog-cancel-button"
					colorType={ props.cancelBtnColorType ? props.cancelBtnColorType : 'grey'}
					onClick={closeDialog}>{ props.cancelBtnText ? props.cancelBtnText : 'Cancel'}</Button>
				<Button
					id="confirmation-dialog-submit-button"
					disabled={props.submitBtnDisabled}
					colorType={props.submitBtnColorType}
					busy={busy}
					onClick={(): void => {
						setBusy(true);
						closeDialog();
						onDelete();
					}}>{props.submitBtnText}</Button>
			</DialogFooter>
		</Dialog>
	);
};

export default ManageTemplateDialog;
